import { apiClient } from './client';

export interface PushAutoRule {
  inactiveDays: number;
  title: string;
  body: string;
  url?: string;
  enabled: boolean;
}

export interface PushAutoConfig {
  enabled: boolean;
  rules: PushAutoRule[];
}

export interface PushAutoStats {
  totalClients: number;
  withPush: number;
  adoptionPct: number;
  sentToday: number;
  sentWeek: number;
}

export const pushAutoApi = {
  get: async (): Promise<PushAutoConfig> => {
    const { data } = await apiClient.get('/admin/push-auto');
    return data as PushAutoConfig;
  },
  set: async (cfg: PushAutoConfig): Promise<PushAutoConfig> => {
    const { data } = await apiClient.put('/admin/push-auto', cfg);
    return data as PushAutoConfig;
  },
  stats: async (): Promise<PushAutoStats> => {
    const { data } = await apiClient.get('/admin/push-auto/stats');
    return data as PushAutoStats;
  },
};
